import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

// shared components
import { SharedModule } from '../../shared/shared.module';
import { BzTabModule } from '../../shared/components/tab/tab.module';
import { BzSwitchModule } from '../../shared/components/switch/switch.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BzTreeModule } from '../../shared/components/tree/tree.module';
import { SecurityAuthenticationRefactorComponent } from './security-authentication-refactor.component';
import { SecurityAuthListComponent } from './security-auth-list/security-auth-list.component';
import { SecurityAuthDetailComponent } from './security-auth-detail/security-auth-detail.component';
import { MultipleAuthDetailComponent } from './multiple-auth-detail/multiple-auth-detail.component';
import { MultipleAuthListComponent } from './multiple-auth-list/multiple-auth-list.component';
import { AuthFormFieldsComponent } from './shared/auth-form-fields/auth-form-fields.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    SecurityAuthenticationRefactorComponent,
    SecurityAuthListComponent,
    MultipleAuthDetailComponent,
    MultipleAuthListComponent,
    SecurityAuthDetailComponent,
    AuthFormFieldsComponent
  ],
  imports: [
    BrowserAnimationsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    BrowserModule,
    FormsModule,
    BzTabModule,
    BzSwitchModule,
    AccordionModule,
    BzTreeModule,
    SharedModule
  ],
  exports: [
    SecurityAuthenticationRefactorComponent
  ],
  providers:[]
})
export class SecurityAuthenticationRefactorModule {}
